/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2024) Takeda. All Rights Reserved
 */

export const COUNTRY_UNAVAILABLE = 'COUNTRY_UNAVAILABLE';
